import React, { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Loader2, Mail } from "lucide-react";

const Login: React.FC = () => {
  const { login, loading, isAuthenticated, user, checkAuthState } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    checkAuthState();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = async () => {
    await login();
  };

  return (
    <div className="brand-backdrop min-h-screen flex flex-col items-center justify-center gap-8 p-4">
      <div className="text-center space-y-3">
        <h1 className="text-3xl sm:text-5xl font-extrabold text-white">
          بوابة وسم الداخلية<span className="text-primary">.</span>
        </h1>
        <p className="text-white/60 text-base sm:text-lg">
          كل ما تحتاجه في مكان واحد
        </p>
      </div>
      <Card className="w-full max-w-md border-0 shadow-2xl">
        <CardHeader className="text-center">
          <img
            src="/uploads/a0faf86a-8d67-40e8-8452-60261fdb6d9b.png"
            alt="WSM"
            className="mx-auto mb-2 h-24 w-24 object-contain"
          />
          <CardTitle className="text-2xl font-bold">
            تسجيل الدخول
          </CardTitle>
          <CardDescription>
            سجل دخولك باستخدام حساب Office 365 الخاص بك
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            onClick={handleLogin}
            disabled={loading}
            className="w-full py-3 text-lg font-medium"
            size="lg"
          >
            {loading ? (
              <>
                <Loader2 className="h-5 w-5 animate-spin" />
                جاري التحميل...
              </>
            ) : (
              <>
                <Mail className="h-5 w-5" />
                تسجيل الدخول بـ Office 365
              </>
            )}
          </Button>

          <div className="mt-6 text-center space-y-4">
            <p className="text-sm text-muted-foreground">
              سيتم توجيهك إلى صفحة تسجيل دخول Microsoft
            </p>

            {/* Support Link */}
            <div className="pt-4 border-t border-border">
              <a
                href="/support"
                className="inline-flex items-center gap-2 text-sm text-primary hover:text-primary-dark hover:underline transition-colors duration-200"
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                تحتاج مساعدة؟ اذهب لصفحة الدعم
              </a>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
